/* eslint-disable object-curly-newline */

export default {
	status: 403,
	data: {
		code: 403,
	},
};
